import React, { useState, useEffect } from 'react'
import ErrorHandler from '../../error-handler/ErrorHandler'
import axiosInstance from '../../api/axiosInstance'
import ModifiedForm from '../layout/form/ModifiedForm'
import { TextArea } from '../layout/form/TextInputFields';
import { useTranslation } from 'react-i18next';
import { Row, Col } from "react-bootstrap";


const EditInstruction = (props) => {
    const { t } = useTranslation();

    const [data, setData] = useState("")
    const getDetails = async () => {
        let result = await axiosInstance.get(`/instructions`)
        if (result) {
            console.log(result.data)
            setData(result.data)
        }
    }

    async function submitInstruction(data) {
        console.log(data)
        for(let key in data){
            if(data[key] === ""){
                delete data[key]
            }
        }
        try {
            const res = await axiosInstance.put(`/instructions/${props.match.params.id}`, data);
            return { type: 1, message: t("success") }
        }
        catch (e) {
            console.log(e)
            return { type: 2, message: e.response.data }

        }
    }
    useEffect(() => {
        getDetails()
    }, [])

    return (
        <>
            <ModifiedForm
                submitFunction={submitInstruction}
                isReset={false}
            >
                <Row>
                    <h4 className="title">{t("instructions.editInstructions")}</h4>

                    <Col lg={12}>
                        <TextArea
                            className="formTextField w-100"
                            id={"text_ar"}
                            title={t("ar")}
                            initial={data?.text_ar}
                        />
                    </Col>
                    <Col lg={12}>
                        <TextArea
                            className="formTextField w-100"
                            id={"text_en"}
                            title={t("en")}
                            initial={data.text_en}
                        />
                    </Col>

                </Row>
             

                <div className="formSubmit">
                    <button className="defaultButton" type="submit" >
                        {t("buttons.finish")}
                    </button>
                </div>
            </ModifiedForm>
        </>
    )
}

export default ErrorHandler(EditInstruction, axiosInstance)